import { I18nConfig } from 'haba-core';
import { deTranslationsHaba } from '../../haba/assets/i18n-assets/de/translations';
import { enTranslationsHaba } from '../../haba/assets/i18n-assets/en/translations';
import { frTranslationsHaba } from '../../haba/assets/i18n-assets/fr/translations';
import { translationChunksConfig } from './translation-chunks-config';

export const habaI18nConfig: I18nConfig = {
  i18n: {
    resources: { en: enTranslationsHaba, de: deTranslationsHaba, fr: frTranslationsHaba },
    chunks: {
      common: ['httpHandlers'],
      habaCart: [
        'habaAddToCartPopup',
        'habaVoucher',
        'habaMiniCart',
        'habaCart',
        'cartProductReplaceErrors',
        'habaCartDetails',
      ],
      habaCheckout: [
        'habaOrderSummary',
        'habaConfirmation',
        'habaPayment',
        'habaPlaceOrder',
        'habaGuestLogin',
        'habaCheckoutProgress',
        'habaCheckoutInforbarText',
        'habaCheckoutReview',
        'habaDeliveryModes',
        'habaCheckoutFooter',
      ],
      habaProduct: [
        'habaProductCard',
        'habaProductDetails',
        'habaProductVariants',
        'habaProductPersonalization',
      ],
      habaCommon: [
        'habaSearch',
        'habaNavigation',
        'habaHttpHandlers',
        'habaAuthentication',
        'habaFooter',
        'habaDelivery',
        'footerNewsletter',
        'habaExternalMessages',
        'countdownBanner',
        'pageHero',
      ],
      habaAddress: ['habaAddressForm', 'habaAddressMelissa'],
      habaContactForm: ['habaContactForm'],
      habaUser: [
        'habaCommonUserInformation',
        'habaLoginForm',
        'habaRegisterForm',
        'habaNavLogin',
        'habaForgottenPassword',
        'habaProRegisterForm',
        'habaAccountOverview',
        'habaCustomerData',
        'habaOrderHistory',
        'habaPasswordRules',
      ],
      habaCountries: ['countries', 'languages'],
      habaMyAccountNavigation: ['myAccountNavigation'],
      habaAltText: ['altText'],
      habaWishlist: [
        'wishlistOverview',
        'wishlistCreate',
        'wishlistEdit',
        'wishlistList',
        'wishlistMove',
        'wishlistAdd',
        'wishlistRemove',
      ],
      ...translationChunksConfig,
    },
    fallbackLang: 'en',
  },
};
